import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-name-dialog',
  templateUrl: './image-name-dialog.component.html',
})
export class ImageNameDialogComponent {
  imageName: string = '';

  constructor(public dialogRef: MatDialogRef<ImageNameDialogComponent>) {
    const lastImage = localStorage.getItem('lastPulledImage');
    if (lastImage) {
      this.imageName = lastImage;
    }
  }

  // Called when dialog closes with OK
  onDialogClose() {
    if (this.imageName && this.imageName.trim()) {
      localStorage.setItem('lastPulledImage', this.imageName.trim());
    }
  }
}
